import { GaTrackingEventCategory, GaTrackingEventName } from '~shared/modules/ga-tracking/constants';
import { ApplicationEventType } from '../constants';
import { ApplicationEvent } from './application-event.model';
import { OptimizelyMethodTypeEnum } from '~shared/modules/application-event/constants/optimizely-method-type.enum';

export class OptimizelyExperimentApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.OptimizelyActivateExperiment;

  constructor(private optimizelyMethodCalled: OptimizelyMethodTypeEnum,
              private action?: string,
              private label?: string | number) {}

  getPayload(): any {
    return {
      event: GaTrackingEventName.OptimizelyActivateExperiment,
      action: this.action,
      label: this.label,
      category: GaTrackingEventCategory.Optimizely,
      method: this.optimizelyMethodCalled
    };
  }
}
